import { createFileRoute } from '@tanstack/react-router'

import { QuestHubPage } from '@/features/quests'

export const Route = createFileRoute('/_event/quests/')({
  component: QuestHubPage
})
